import { useCallback, useState } from "react";

/**
 * État de pagination réutilisable pour les listings back-office.
 * - `setSize` remet automatiquement la page à 0 (changer la taille rebat les pages).
 * - `resetToFirstPage()` : à appeler depuis les setters de filtres/recherche.
 */
export function usePaginationState(initialSize = 20) {
  const [page, setPage] = useState(0);
  const [size, setSizeRaw] = useState(initialSize);
  const setSize = useCallback((s: number) => {
    setSizeRaw(s);
    setPage(0);
  }, []);
  const resetToFirstPage = useCallback(() => setPage(0), []);
  return { page, size, setPage, setSize, resetToFirstPage };
}
